import { render } from "./DashboardTitle.vue?vue&type=template&id=4c41835c&scoped=true"
import script from "./DashboardTitle.vue?vue&type=script&lang=js"
export * from "./DashboardTitle.vue?vue&type=script&lang=js"

import "./DashboardTitle.vue?vue&type=style&index=0&id=4c41835c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c41835c"]])

export default __exports__